module.exports = __webpack_public_path__ + "img/beianicon.6747f497.png";